import React from 'react';

const ThoughtBubbleIcon = ({ className = "", size = 24, fill = "currentColor" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            {/* 
               Matched to Reference Image:
               - Solid, puffy cloud.
               - 3 descending dots.
            */}

            <g transform="translate(1, -1)"> {/* Slight adjustment to center visually */}
                <path
                    d="M17.5 19C19.9853 19 22 16.9853 22 14.5C22 12.132 20.177 10.244 17.8 10.05C17.5 6.4 14.5 3.5 10.8 3.5C7.5 3.5 4.7 5.8 3.9 8.9C1.7 9.5 0 11.5 0 14C0 16.8 2.2 19 5 19H17.5Z"
                    fill={fill === "currentColor" ? "currentColor" : fill}
                />

                {/* 3 Circular bubbles leading away */}
                <circle cx="4" cy="21" r="1.5" fill={fill === "currentColor" ? "currentColor" : fill} />
                <circle cx="2" cy="23.5" r="1" fill={fill === "currentColor" ? "currentColor" : fill} />
            </g>
        </svg>
    );
};

export default ThoughtBubbleIcon;
